import { render, staticRenderFns } from "./SessionInvalidModal.vue?vue&type=template&id=2b602e00&scoped=true"
import script from "./SessionInvalidModal.vue?vue&type=script&lang=js"
export * from "./SessionInvalidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b602e00",
  null
  
)

export default component.exports